import React from 'react'
import SewingRepairInBatchPage from './SewingRepairInBatchPage'
import '../styles/index.scss'

function SewingRepairInBatchContainer() {
  return (
    <div className='SewingRepairInBatchContainer'>
        <SewingRepairInBatchPage/>
    </div>
  )
}

export default SewingRepairInBatchContainer